import { render, staticRenderFns } from "./chargesExternesAndCA.vue?vue&type=template&id=2a22d9c4&"
import script from "./chargesExternesAndCA.vue?vue&type=script&lang=js&"
export * from "./chargesExternesAndCA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports